import { useEffect, useState } from 'react';

/**
 * Reactive `window.matchMedia` matcher. The initial value is read
 * synchronously so a mobile-only branch doesn't flash the desktop tree on
 * first paint (and SSR-safe: falls back to `false` when there's no window).
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** ≤768px — the breakpoint the mobile nav (Variant B) and Home cockpit use. */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 768px)');
}
